import {
	Avatar,
	ListItem,
	ListItemAvatar,
	ListItemText,
	useMediaQuery,
	useTheme,
} from '@mui/material';

function LoginRightListItem(props) {
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));
	const { isConsentRenewal } = props;
	const { number, text, fontFamily } = props;

	// Check for dark theme
	const isDark =
		props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';

	return (
		<ListItem
			disablePadding={isConsentRenewal ? true : mobileScreen}
			sx={{
				paddingLeft: '0',
				...(isConsentRenewal && {
					paddingTop: '0',
					paddingBottom: '0',
					marginBottom: '0.5rem',
					alignItems: 'flex-start',
				}),
			}}
		>
			<ListItemAvatar
				sx={{
					marginTop: isConsentRenewal ? '0.25rem' : '0.5rem',
					...(isConsentRenewal && {
						alignSelf: 'flex-start',
					}),
				}}
			>
				<Avatar
					sx={{
						width: isConsentRenewal
							? '0.75rem'
							: mobileScreen
							? '20px'
							: '27px',
						height: isConsentRenewal
							? '0.75rem'
							: mobileScreen
							? '20px'
							: '27px',
						fontSize: isConsentRenewal
							? '0.625rem'
							: mobileScreen
							? '0.825rem'
							: '1rem',
						fontWeight: isConsentRenewal ? 500 : 700,
						marginRight: isConsentRenewal ? '0.5rem' : '1rem',
						backgroundColor: props.customDetails.primaryColor,
						color: isDark ? '#161616' : '#fff',
					}}
				>
					{number}
				</Avatar>
			</ListItemAvatar>
			<ListItemText
				disableTypography
				sx={{
					fontSize: isConsentRenewal
						? '0.875rem'
						: mobileScreen
						? '0.825rem'
						: '1.125rem',
					fontFamily: fontFamily,
					color:
						props.customDetails?.secondaryTextColor ??
						(isDark ? '#7A8185' : '#000'),
					...(isConsentRenewal && {
						lineHeight: '1.25rem',
						marginTop: '0',
					}),
				}}
				primary={text}
			/>
		</ListItem>
	);
}

export default LoginRightListItem;
